const getTargetName = (e: any) => e.target.name;

export default getTargetName;
